import Modal from "@visiblethread/react-components/dist/components/Modal";
import React from "react";
import * as PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { removeErrorMessage } from "slices/app/errorSlice";
import { modalTypes } from "constants/types";
import { hideModal } from "slices/app/actions/modals";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";

const ConfirmationModal = ({
  headerText,
  bodyText,
  okButton,
  cancelButton,
  onClose,
}) => {
  const confError = useSelector((state) => state.error.errorMessage);
  const dispatch = useDispatch();

  const handleOk = () => {
    dispatch(removeErrorMessage);
    okButton.onOk();
  };

  const handleCancel = () => {
    dispatch(removeErrorMessage);
    dispatch(hideModal(modalTypes.CONFIRMATION));
    cancelButton?.onCancel();
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      data-testid="confirmation-modal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <b>{headerText}</b>
      </Modal.Header>
      <Modal.Body style={{ whiteSpace: "break-spaces" }}>
        {confError || bodyText}
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-testid="save-button"
          variant={buttonVariants.primary}
          onClick={handleOk}
          content={okButton.text}
        />
        {cancelButton ? (
          <Button
            data-testid="cancel-button"
            variant={buttonVariants.secondary}
            onClick={handleCancel}
            content={cancelButton.text}
          />
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;

ConfirmationModal.propTypes = {
  headerText: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  okButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onOk: PropTypes.func.isRequired,
  }).isRequired,
  cancelButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
  }),
  onClose: PropTypes.func,
};
